import React from 'react';
import { Grid } from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import { useStyles } from './styles';

const ProcessingMedia = () => {
  const classes = useStyles();

  return (
    <Grid item style={{ textAlign: 'center' }}>
      <div className={classes.loader}>
        <ScaleLoader color="#DCDEE5" css="animation-duration: 2s" loading />
      </div>
      <p className={classes.renderStatus}>Processing media</p>
    </Grid>
  );
};

export default ProcessingMedia;
